import { SET_ERROR } from "./types";

export const setError = (statusCode, statusText, message) => ({
    type: SET_ERROR,
    payload: {
        statusCode,
        statusText,
        message
    }
});